import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
    return {
        dialogPaper: {
            width: 444,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[16]
        },
        dialogContent: {
            display: "flex",
            padding: "0 24px 20px 24px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(3),
            alignSelf: "stretch",
        },
        list: {
            paddingLeft: theme.spacing(3),
            margin: 0,
        },
        dialogActions: {
            padding: theme.spacing(1),
            justifyContent: "flex-end",
            gap: theme.spacing(1)
        },
        dialogButton: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(0.75),
            paddingBotton: theme.spacing(0.75),
            textTransform: "uppercase",
            fontWeight: 500
        },
        customDropDown: {
            width: "100%",
        },
        commentsInputField: {
            width: "100%"
        },
    };
});
